import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailLabel} from '../mapping-classes/detail-label';
import {LazyLoadingData} from '../mapping-classes/lazy-loading-data';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {ButtonData} from '../mapping-classes/button-data';

export class Zekervoorjepersoneel implements DetailScreen {
  restrictedData: boolean;
  actualityDateTime: string;
  title: string;
  buttons: ButtonData[];
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = 'Zeker voor je personeel';
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.actualityDateTime = response.detailsViewObject['actualityDateTime'];
      this.buttons = [];
      this.addButtons(response);
    }
    if (response.listOfError && response.listOfError.length !== 0) {
      this.createErrorMessage(response);
    } else {
      if (response.detailsViewObject && response.detailsViewObject.restrictedData) {
        this.restrictedData = response.detailsViewObject.restrictedData;
      }
      this.panels = [];
      this.nameValues = [];

      this.setPanels();
      this.setNameAndValues();
      this.addSubHeadersToAbsencePanel(this.panels[3], response);
      this.setLazyLoadingData(this.panels[4], response);
      this.addValues(response);
    }
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  addButtons(response) {
    this.buttons.push(new ButtonData('productservicesurl', response.detailsViewObject['arrangementNumber'],
      response.detailsViewObject['administrationCode'], response.detailsViewObject['commercialProductTypeCode']));
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    this.panels.push(new DetailPanel('Bedrijfsgegevens'));
    this.panels.push(new DetailPanel('Verzuim'));
    this.panels.push(new DetailPanel('Vorderingen'));
  }

  setNameAndValues() {
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.fillProductDetailsPanel(productDetailsPanel);

    const productAgreementsPanel: DetailPanel = this.panels[1];
    this.fillProductAgreementsPanel(productAgreementsPanel);

    const companyInformationPanel: DetailPanel = this.panels[2];
    this.fillCompanyInformationPanel(companyInformationPanel);
  }

  private setLazyLoadingData(claimsPanel: DetailPanel, response) {
    claimsPanel.isLazyLoaded(true);
    if (response.detailsViewObject && response.detailsViewObject.number) {
      claimsPanel.lazyLoadingData = new LazyLoadingData(response.detailsViewObject['number'], '14', 'claims');
    }
  }

  addValues(response) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.addValuesToProductDetailsPanel(productDetailsPanel, obj);
    const productAgreementsPanel: DetailPanel = this.panels[1];
    this.addValuesToProductAgreementsPanel(productAgreementsPanel, obj);
    const companyInformationPanel: DetailPanel = this.panels[2];
    this.addValuesToCompanyInformationPanel(companyInformationPanel, obj);
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('insuranceCompany', new DetailLabel('Maatschappij'));
    productDetailsPanel.nameAndValues.set('branchDescription', new DetailLabel('Branche omschrijving'));
    productDetailsPanel.nameAndValues.set('number', new DetailLabel('Polisnummer'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('insuranceCompany').setValue(obj.insuranceCompany);
    productDetailsPanel.nameAndValues.get('branchDescription').setValue(obj.branchDescription);
    productDetailsPanel.nameAndValues.get('number').setValue(obj.number);
  }

  private fillProductAgreementsPanel(productAgreementsPanel: DetailPanel) {
    productAgreementsPanel.nameAndValues.set('annualCustomerPremiumAmount', new DetailLabel('Jaarpremie'));
    productAgreementsPanel.nameAndValues.set('premiumPaymentStartDate', new DetailLabel('Ingangsdatum'));
    productAgreementsPanel.nameAndValues.set('premiumPaymentEndDate', new DetailLabel('Einddatum'));
    productAgreementsPanel.nameAndValues.set('renewalDate', new DetailLabel('Eerstvolgende prolongatiedatum'));
    productAgreementsPanel.nameAndValues.set('premiumPaymentFrequencyCode', new DetailLabel('Betaalfrequentie'));
    productAgreementsPanel.nameAndValues.set('insuranceAnnualCommissionAmount', new DetailLabel('Jaarlijks provisiebedrag'));
    productAgreementsPanel.nameAndValues.set('premiumCollectionIBAN', new DetailLabel('Incassorekeningnummer'));
  }

  private addValuesToProductAgreementsPanel(productAgreementsPanel: DetailPanel, obj) {
    if (!this.restrictedData) {
      productAgreementsPanel.nameAndValues.get('annualCustomerPremiumAmount').setValue(obj.annualCustomerPremiumAmount);
      productAgreementsPanel.nameAndValues.get('annualCustomerPremiumAmount').setType('amount');
      productAgreementsPanel.nameAndValues.get('insuranceAnnualCommissionAmount').setValue(obj.insuranceAnnualCommissionAmount);
      productAgreementsPanel.nameAndValues.get('insuranceAnnualCommissionAmount').setType('amount');
    } else {
      productAgreementsPanel.nameAndValues.get('annualCustomerPremiumAmount').setValue(this.shieldedText);
      productAgreementsPanel.nameAndValues.get('insuranceAnnualCommissionAmount').setValue(this.shieldedText);
    }
    productAgreementsPanel.nameAndValues.get('premiumPaymentStartDate').setValue(obj.premiumPaymentStartDate);
    productAgreementsPanel.nameAndValues.get('premiumPaymentEndDate').setValue(obj.premiumPaymentEndDate);
    productAgreementsPanel.nameAndValues.get('renewalDate').setValue(obj.renewalDate);
    productAgreementsPanel.nameAndValues.get('premiumPaymentFrequencyCode').setValue(obj.premiumPaymentFrequencyCode);
    productAgreementsPanel.nameAndValues.get('premiumCollectionIBAN').setValue(obj.premiumCollectionIBAN);
  }

  private fillCompanyInformationPanel(companyInformationPanel: DetailPanel) {
    companyInformationPanel.nameAndValues.set('interpolisIndustryClassificationDescription', new DetailLabel('Bedrijfsactiviteit'));
  }

  private addValuesToCompanyInformationPanel(companyInformationPanel: DetailPanel, obj) {
    companyInformationPanel.nameAndValues.get('interpolisIndustryClassificationDescription')
      .setValue(obj.interpolisIndustryClassificationDescription);
  }

  private addSubHeadersToAbsencePanel(absencePanel: DetailPanel, response) {
    const obj = response.detailsViewObject;
    absencePanel.subPanels.push(new DetailPanel('Dekkingen'));
    if (response.detailsViewObject && response.detailsViewObject.hasCoverages) {
      const coveragesPanel = absencePanel.subPanels[0];
      coveragesPanel.subPanels.push(new DetailPanel('Loondoorbetaling'));
      coveragesPanel.subPanels.push(new DetailPanel('Dekkingsperiode'));
      coveragesPanel.subPanels.push(new DetailPanel('Werkgeverslasten'));
      coveragesPanel.subPanels.push(new DetailPanel('Verzuimmanagement'));
      this.addFieldsToSubHeader(coveragesPanel);
      this.fillSubHeader(coveragesPanel, obj);
    } else {
      const coveragesPanel = absencePanel.subPanels[0];
      coveragesPanel.errorText = 'Voor deze polis zijn geen dekkingen beschikbaar.';
    }
  }

  private addFieldsToSubHeader(coveragesPanel: DetailPanel) {
    const continuedPaymentOfWagesSubPanel = coveragesPanel.subPanels[0];
    continuedPaymentOfWagesSubPanel.nameAndValues.set('insuranceOccupationalDisabilityOwnRiskPeriodNumberOfDays',
      new DetailLabel('Eigenrisico periode'));
    continuedPaymentOfWagesSubPanel.nameAndValues.set('insuranceAbsenteeismPeriodsDescription',
      new DetailLabel('Dekkingsperiode'));

    const coveragePeriodSubPanel = coveragesPanel.subPanels[1];
    coveragePeriodSubPanel.nameAndValues.set('period1', new DetailLabel('Jaar/Periode 1'));
    coveragePeriodSubPanel.nameAndValues.set('period2', new DetailLabel('Jaar/Periode 2'));
    coveragePeriodSubPanel.nameAndValues.set('period3', new DetailLabel('Jaar/Periode 3'));
    coveragePeriodSubPanel.nameAndValues.set('period4', new DetailLabel('Jaar/Periode 4'));

    const employersChargesSubPanel = coveragesPanel.subPanels[2];
    employersChargesSubPanel.nameAndValues.set('insuranceAbsenteeismEmployersExpensesCoveragePercentage',
      new DetailLabel('Dekkingspercentage'));

    const absenceManagementSubPanel = coveragesPanel.subPanels[3];
    absenceManagementSubPanel.nameAndValues.set('insuranceCoverageProductDescription', new DetailLabel('Arbodienst'));
    absenceManagementSubPanel.nameAndValues.set('insuranceAbsenteeismAchmeaGuidanceTypeCode',
      new DetailLabel('Casemanagement'));
    absenceManagementSubPanel.nameAndValues.set('insuranceAbsenteeismInterventionCompensationCheck',
      new DetailLabel('Interventievergoeding'));
    absenceManagementSubPanel.nameAndValues.set('insuranceAbsenteeismInterventionCompensationPercentage',
      new DetailLabel('Vergoedingspercentage'));
  }

  private fillSubHeader(coveragesPanel: DetailPanel, obj) {
    const employersChargesCoverages = [];
    obj.coverages.forEach((coverage) => {
      if (coverage.insuranceCoverageProductPackageCode === 'SK0SN1000A0000' && coverage.insuranceCoverageProductCode === 'SKORN1000A0000') {
        this.fillContinuedPaymentOfWagesAndCoveragePeriodHeaders(coveragesPanel, coverage);
      }
      if (coverage.insuranceCoverageProductPackageCode === 'SK0SN1000A0000' && coverage.insuranceCoverageProductCode === 'SKRRN1000A0000') {
        this.fillAbsenceManagementHeader(coveragesPanel, coverage);
      }
      if (coverage.insuranceCoverageProductPackageCode === 'SKAYN1000A0000') {
        employersChargesCoverages.push(coverage);
      }
    });
    if (employersChargesCoverages.length > 0) {
      this.fillEmployersChargesHeader(coveragesPanel, employersChargesCoverages);
    }
  }

  private fillContinuedPaymentOfWagesAndCoveragePeriodHeaders(coveragesPanel: DetailPanel, coverage) {
    const continuedPaymentOfWagesSubPanel = coveragesPanel.subPanels[0];
    continuedPaymentOfWagesSubPanel.nameAndValues.get('insuranceOccupationalDisabilityOwnRiskPeriodNumberOfDays')
      .setValue(coverage.insuranceOccupationalDisabilityOwnRiskPeriodNumberOfDays + ' dagen');
    continuedPaymentOfWagesSubPanel.nameAndValues.get('insuranceAbsenteeismPeriodsDescription').setValue(coverage.coveragePeriod);

    const coveragePeriodSubPanel = coveragesPanel.subPanels[1];
    if (coverage.periodOnePercentage !== undefined) {
      coveragePeriodSubPanel.nameAndValues.get('period1')
        .setValue(coverage.periodOnePercentage + '% over ' + coverage.periodOneNumber + ' ' + coverage.periodOnePeriodType);
    } else {
      coveragePeriodSubPanel.nameAndValues.get('period1').setValue('');
    }
    if (coverage.periodTwoPercentage !== undefined) {
      coveragePeriodSubPanel.nameAndValues.get('period2')
        .setValue(coverage.periodTwoPercentage + '% over ' + coverage.periodTwoNumber + ' ' + coverage.periodTwoPeriodType);
    } else {
      coveragePeriodSubPanel.nameAndValues.get('period2').setValue('');
    }
    if (coverage.periodThreePercentage !== undefined) {
      coveragePeriodSubPanel.nameAndValues.get('period3')
        .setValue(coverage.periodThreePercentage + '% over ' + coverage.periodThreeNumber + ' ' + coverage.periodThreePeriodType);
    } else {
      coveragePeriodSubPanel.nameAndValues.get('period3').setValue('');
    }
    if (coverage.periodFourPercentage !== undefined) {
      coveragePeriodSubPanel.nameAndValues.get('period4')
        .setValue(coverage.periodFourPercentage + '% over ' + coverage.periodFourNumber + ' ' + coverage.periodFourPeriodType);
    } else {
      coveragePeriodSubPanel.nameAndValues.get('period4').setValue('');
    }
  }

  private fillAbsenceManagementHeader(coveragesPanel: DetailPanel, coverage) {
    const employersChargesSubPanel = coveragesPanel.subPanels[2];
    employersChargesSubPanel.nameAndValues.get('insuranceAbsenteeismEmployersExpensesCoveragePercentage')
      .setValue(coverage.insuranceAbsenteeismEmployersExpensesCoveragePercentage);
    employersChargesSubPanel.nameAndValues.get('insuranceAbsenteeismEmployersExpensesCoveragePercentage')
      .setType('percentage');
  }

  private fillEmployersChargesHeader(coveragesPanel: DetailPanel, coverages) {
    const absenceManagementSubPanel = coveragesPanel.subPanels[3];
    coverages.forEach((coverage) => {
      if (coverage.insuranceCoverageProductPackageCode === 'SKAYN1000A0000' && coverage.insuranceCoverageProductCode
        === ('SK1YN1000A0000' || 'SKYXN1000A0000')) {
        absenceManagementSubPanel.nameAndValues.get('insuranceCoverageProductDescription')
          .setValue(coverage.insuranceCoverageProductDescription);
      }
      if (coverage.insuranceCoverageProductPackageCode === 'SKAYN1000A0000' && coverage.insuranceCoverageProductCode
        === ('SKVXN1000A0000')) {
        absenceManagementSubPanel.nameAndValues.get('insuranceAbsenteeismAchmeaGuidanceTypeCode')
          .setValue(coverage.insuranceAbsenteeismAchmeaGuidanceTypeCode);
      }
      if (coverage.insuranceCoverageProductPackageCode === 'SKAYN1000A0000' && coverage.insuranceCoverageProductCode
        === ('SK4YN1000A0000')) {
        absenceManagementSubPanel.nameAndValues.get('insuranceAbsenteeismInterventionCompensationCheck')
          .setValue(coverage.insuranceAbsenteeismInterventionCompensationCheck);
        absenceManagementSubPanel.nameAndValues.get('insuranceAbsenteeismInterventionCompensationPercentage')
          .setValue(coverage.insuranceAbsenteeismInterventionCompensationPercentage);
        absenceManagementSubPanel.nameAndValues.get('insuranceAbsenteeismInterventionCompensationPercentage')
          .setType('percentage');
      }
    });
  }

}
